import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import nl from "./locales/nl.json";

// Detect user language from browser or fallback
const userLocale = navigator.language.split("-")[0] || "en";

// Create I18n instance
const i18n = createI18n({
  locale: userLocale, // Default locale based on browser language
  fallbackLocale: "en", // Fallback to English if the translation is missing
  messages: {
    en,
    nl
  }
});

export default i18n;
